import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import { buildOrderLabelBatch } from '../../services/godexLabelBuilder';
import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'PrinterSetupHelp';

/**
 * Workstation setup checklist and dev EZPL download.
 */
const PrinterSetupHelp = ({ orderId, labels = [] }) => {
  const [openKey, setOpenKey] = useState(null);
  const isDev = process.env.NODE_ENV !== 'production';

  const handleDownloadEzpl = () => {
    if (!labels.length) return;
    const ezpl = buildOrderLabelBatch(labels);
    const blob = new Blob([ezpl], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `order-${orderId ?? 'labels'}-stock-labels.ezpl`;
    anchor.click();
    URL.revokeObjectURL(url);
    logInfo(LOG_CONTEXT, 'ezpl downloaded', { orderId, count: labels.length });
  };

  return (
    <Accordion activeKey={openKey} onSelect={k => setOpenKey(k)} className="mb-3">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Label printer setup help</Accordion.Header>
        <Accordion.Body className="small">
          <ol className="mb-0 ps-3">
            <li>Install GoDEX driver and connect the DT2 by USB.</li>
            <li>Rename the queue to <strong>GoDEX DT2 - Materiah</strong>.</li>
            <li>Install QZ Tray and keep it running in the system tray.</li>
            <li>Load 38×12 mm labels and calibrate gap/sensor in GoLabel.</li>
            <li>Approve browser permission when Materiah connects to QZ Tray.</li>
          </ol>
          {isDev && labels.length ? (
            <Button
              variant="link"
              size="sm"
              className="px-0 mt-2 print-labels-modal__dev-download"
              onClick={handleDownloadEzpl}
            >
              Download raw EZPL (dev)
            </Button>
          ) : null}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default PrinterSetupHelp;
